import type { RuleObject } from 'antd/es/form';
import dayjs from 'dayjs';

export const validateDateSmallerThanToday = (
  rule: RuleObject,
  value: string
): Promise<void> => {
  if (!value) return Promise.reject();

  if (dayjs(value).isAfter(dayjs(), 'day')) {
    return Promise.reject(new Error(rule.message as string));
  }

  return Promise.resolve();
};
